var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.246 16.538h6.508c.882 0 1.312-.437 1.312-1.394v-5.018c0-.861-.355-1.306-1.087-1.38V7.021c0-2.577-1.688-3.82-3.479-3.82-1.791 0-3.48 1.243-3.48 3.82V8.78c-.67.103-1.086.54-1.086 1.347v5.018c0 .957.43 1.394 1.312 1.394zm.875-9.66c0-1.715 1.1-2.624 2.379-2.624 1.278 0 2.379.91 2.379 2.625v1.86l-4.758.006V6.88z"
  })));
}

export default __webpack_public_path__ + "static/media/lock-fill.b7e96b88.svg";
export { SvgLockFill as ReactComponent };